import { Fragment } from "react";
import "./MetaverseDevelopment.css";
import { metaverseDevelopment } from "../../staticdata";
import metaversedevbanner from "../../assets/images/services/metaverse/metaversedevbanner.jpg";


const MetaverseDevelopment = () => {
  return (
    <Fragment>
      <section className="metaversedev-style">
        <div className="metaversedev-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="metaversedev-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Metaverse Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  At Kairaa, a leading Metaverse development company, we create
                  virtual experiences that address real business challenges,
                  enhance engagement with avatar-driven experiences, boost
                  performance, and future-proof your brand – all without
                  geographical limitations.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={metaversedevbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="metaversedev-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Metaverse Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {metaverseDevelopment.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="metaversedev-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default MetaverseDevelopment;
